var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "helloWard" },
      [
        _c("div", { staticClass: "playerInfoBox" }, [
          _c("div", { staticClass: "playInfoItem" }, [
            _c("div", { staticClass: "infoLabel" }, [_vm._v("参加项目总数")]),
            _vm._v(" "),
            _vm.playerInfo.joinMatchCount
              ? _c("div", { staticClass: "infoMsg" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.playerInfo.joinMatchCount) +
                      "\n        "
                  ),
                ])
              : _c("div", { staticClass: "noRecord" }, [_vm._v("暂无记录")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "playInfoItem" }, [
            _c("div", { staticClass: "infoLabel" }, [_vm._v("历史获奖次数")]),
            _vm._v(" "),
            _vm.playerInfo.getPrizeCount
              ? _c("div", { staticClass: "infoMsg" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.playerInfo.getPrizeCount) +
                      "\n        "
                  ),
                ])
              : _c("div", { staticClass: "noRecord" }, [_vm._v("暂无记录")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "playInfoItem" }, [
            _c("div", { staticClass: "infoLabel" }, [_vm._v("历史最佳成绩")]),
            _vm._v(" "),
            _vm.playerInfo.maxPrize
              ? _c("div", { staticClass: "infoMsg" }, [
                  _vm._v("\n          第"),
                  _c("span", { staticClass: "colorSpan" }, [
                    _vm._v(_vm._s(_vm.playerInfo.maxPrize)),
                  ]),
                  _vm._v("名\n        "),
                ])
              : _c("div", { staticClass: "noRecord" }, [_vm._v("暂无记录")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "playInfoItem" },
            [
              _c("div", { staticClass: "infoLabel" }, [_vm._v("系统通知")]),
              _vm._v(" "),
              _vm.list.length > 0
                ? _vm._l(_vm.list, function (i) {
                    return _c("div", { key: i.id, staticClass: "infoNews" }, [
                      _vm._v(
                        "\n            " + _vm._s(i.title) + "\n          "
                      ),
                    ])
                  })
                : _c("div", { staticClass: "noRecord" }, [_vm._v("暂无记录")]),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "noLineTitle" }, [_vm._v("正在进行的项目")]),
        _vm._v(" "),
        _c("ZhjyTable", {
          attrs: {
            minWidth: _vm.minWidth,
            tableData: _vm.listData,
            columList: _vm.defaultColumn,
            pageNum: _vm.page.pageNum,
            pageSize: _vm.page.pageSize,
            options: _vm.options,
          },
          on: {
            "update:pageNum": function ($event) {
              return _vm.$set(_vm.page, "pageNum", $event)
            },
            "update:page-num": function ($event) {
              return _vm.$set(_vm.page, "pageNum", $event)
            },
            enter: _vm.enter,
          },
        }),
        _vm._v(" "),
        _c("ZhjyPagination", {
          attrs: {
            pageNum: _vm.page.pageNum,
            pageSize: _vm.page.pageSize,
            total: _vm.totalData,
          },
          on: {
            "update:pageNum": function ($event) {
              return _vm.$set(_vm.page, "pageNum", $event)
            },
            "update:page-num": function ($event) {
              return _vm.$set(_vm.page, "pageNum", $event)
            },
            handleCurrentChange: _vm.handleCurrentChange,
            handleSizeChange: _vm.handleSizeChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }